import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "./button";
import { Card, CardContent } from "./card";
import InputField from "./InputField";
import SelectField from "./SelectField";

const AreaForm = ({ area, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    grupo: "",
  });

  const [grupos, setGrupos] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // 🔹 loading state

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  // 🔹 Cargar grupos dinámicos
  useEffect(() => {
    axios
      .get(`${API}/area-grupos`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setGrupos(res.data))
      .catch(() => setGrupos([]));
  }, [API, token]);

  // 🔹 Edición
  useEffect(() => {
    if (area) {
      setFormData({
        name: area.name || "",
        grupo: area.grupo?._id || area.grupo || "",
      });
    }
  }, [area]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    try {
      setIsLoading(true);
      await onSave(formData);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-semibold">
            {area ? "Editar área" : "Nueva área"}
          </h2>
          <button onClick={onClose} className="text-xl" disabled={isLoading}>
            ✕
          </button>
        </div>

        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <InputField
                label="Nombre *"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Área"
                required
                disabled={isLoading}
              />

              <SelectField
                label="Grupo *"
                name="grupo"
                value={formData.grupo}
                onChange={handleChange}
                options={grupos}
                displayFn={(g) => g.name}
                isDisabled={isLoading}
              />

              <div className="flex justify-end gap-2 pt-4">
                <Button
                  variant="outline"
                  onClick={onClose}
                  type="button"
                  disabled={isLoading}
                >
                  Cancelar
                </Button>

                <Button type="submit" disabled={isLoading}>
                  {isLoading
                    ? area
                      ? "Actualizando..."
                      : "Creando..."
                    : area
                      ? "Actualizar"
                      : "Crear"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AreaForm;
